export default __webpack_public_path__ + "static/media/no_posts.9346dc11.svg";